import { render, staticRenderFns } from "./ContentDetails.vue?vue&type=template&id=2237fa97&"
import script from "./ContentDetails.vue?vue&type=script&lang=js&"
export * from "./ContentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports